import React from "react";
import { connect } from "react-redux";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import detect from "detect-browser";
import MainPage from "./pages/MainPage";
import { LoginPage } from "./pages/LoginPage";
import { toggleContrast } from "./actions/accessibilityActions";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import NewPasswordPage from "./pages/NewPasswordPage";
import RegistrationPage from "./pages/RegistrationPage";
import SecureRoute from "./components/SecureRoute";
import KioskPage from "./kiosk/KioskPage";
import NotificationService from "./services/notificationService";

const App = props => {
  NotificationService.initializeNotifications(
    props.kiosk,
    detect.detect().os.indexOf("Android") !== -1
  );

  var savedDarkTheme = JSON.parse(window.localStorage.getItem("darkTheme"));
  if (savedDarkTheme && savedDarkTheme !== props.isHighContrast) {
    props.toggleContrast();
  }

  var text = props.text;
  var titles = {
    login: text("titles.login"),
    resetpassword: text("titles.resetpassword"),
    newpassword: text("titles.newpassword"),
    registration: text("titles.registration"),
    about: text("titles.about"),
  };

  return (
    <Router>
      <Switch>
        <Route
          path="/login"
          render={() => <LoginPage title={titles["login"]} />}
        />
        <Route
          path="/resetpassword"
          render={() => <ResetPasswordPage title={titles["resetpassword"]} />}
        />
        <Route
          path="/newpassword"
          render={() => <NewPasswordPage title={titles["newpassword"]} />}
        />
        <Route
          path="/registration/:orgid"
          render={() => <RegistrationPage title={titles["registration"]} />}
        />
        <Route
          path="/registration"
          render={() => <RegistrationPage title={titles["registration"]} />}
        />
        <Route path="/oneclickcall" component={KioskPage} />
        <SecureRoute
          path="/"
          component={MainPage}
          isAuthenticated={props.isAuthenticated}
        />
      </Switch>
    </Router>
  );
};

const mapStateToProps = (state, props) => {
  return {
    text: state.config.text,
    isHighContrast: state.accessibility.isHighContrast,
    isAuthenticated: state.user.authenticated,
    kiosk: state.config.mode.kiosk,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleContrast: () => {
      return dispatch(toggleContrast());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);






// WEBPACK FOOTER //
// ./src/App.js